import request from '@utils/axiosWrapper';

export const GetBookingInfoUrl = '/gw/api/operation/openrest/booking/info';

export interface BookingInfo {
    tittle: string;
    detail: string;
    firstButton: string;
    secondButton: string;
    isHasBookingInfo: boolean;
}

export const getBookingInfo = () => request.get<BookingInfo>(GetBookingInfoUrl);
